export default "__VITE_ASSET__CxbYK7i5__"